import InstantMatchBannerVideo from '../assets/marketplace-banner-video.mov'

import InstantMatchButton from './instant-match-button'

export default function HomeMarketplaceBanner() {
  return (
    <div className="px-5 pt-5 md:px-8 md:pb-2 md:pt-8">
      <div className="relative flex h-[200px] flex-col overflow-hidden rounded-[25px] md:h-[320px] md:rounded-[50px]">
        <video autoPlay loop muted playsInline className="relative top-1/2 size-full -translate-y-1/2 object-cover">
          <source src={InstantMatchBannerVideo} type="video/mp4" />
        </video>
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-5 bg-gradient-to-b from-black/30 to-transparent p-7 md:gap-9 md:p-8">
          <div className="flex items-center justify-center text-center text-[28px] font-bold leading-[1.35] text-white md:text-[46px]">
            Homeownership starts here
          </div>
          <InstantMatchButton
            text="Instant match me!"
            className="w-full bg-white py-4 text-[16px] text-primary hover:bg-white/90 md:w-[375px] md:px-[96px] md:py-5 md:text-[20px]"
          />
        </div>
      </div>
    </div>
  )
}
